import { createApi } from '@reduxjs/toolkit/query/react';

import { extractData } from '@app/store/utils/common';
import {
  Balance,
  BalanceHistoryRequest,
  BalanceHistoryRow,
  BalanceTagType,
} from '@app/store/slices/balance/balanceTypes';
import { baseQueryWithReauth } from '@app/store/utils/baseQueryWithReauth';

export const balanceApi = createApi({
  reducerPath: 'balanceApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: Object.values(BalanceTagType),
  endpoints: (builder) => ({
    getBalance: builder.query<Balance | null, void>({
      query: () => ({
        url: '/users/me/balance',
        method: 'GET',
      }),
      transformResponse: extractData,
      providesTags: [BalanceTagType.BALANCE],
    }),
    getUserBalance: builder.query<Balance | null, number>({
      query: (userId) => `/users/balance/${String(userId)}`,
      transformResponse: extractData,
    }),
    getBalanceHistory: builder.query<BalanceHistoryRow[] | null, BalanceHistoryRequest>({
      query: (params) => ({ url: '/users/me/balance/history', params }),
      transformResponse: extractData,
      providesTags: [BalanceTagType.BALANCE_HISTORY],
    }),
  }),
});

export const { useGetBalanceQuery, useGetUserBalanceQuery, useGetBalanceHistoryQuery } = balanceApi;
